import Image from 'next/image';
import './styles.css';
import LoaderIcon from '@/assests/icons/loader.svg';
import { cn } from '@/lib/cn';
interface SpinnerProps {
  size?: number;
  color?: 'white' | 'black';
  className?: string;
}
function Spinner({
  size = 24,
  color = 'white',
  className
}: SpinnerProps) {
  return <span className={cn('wrapper', className)} style={{
    width: size,
    height: size
  }} data-sentry-component="Spinner" data-sentry-source-file="index.tsx">
      <Image src={LoaderIcon} alt="Loader" style={{
      filter: color === 'white' ? 'invert(100%)' : 'invert(0%)'
    }} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </span>;
}
export default Spinner;